import Checkbox from "components/ui/checkbox/Checkbox";
import Drawer, { DrawerType } from "components/ui/drawer/Drawer";
import { useEffect, useState } from "react";
import { VOA_TOS_LINK } from "utilities/Constant";
import "./tos-drawer.scss";
import { Button } from "components/v2/button/Button";
import { SsoIframe } from "pages/online-verification/SsoIframe";
import { useSelector } from "react-redux";
import { getNhDealApplicationId, getUserRole } from "features/authSlice";
import { CreateVerificationOrder, useCreateVerificationOrderMutation, useSyncVerificationDataMutation, VerificationType } from "pages/online-verification/verificationService";
import { trackFSOptedVoaEvent, trackFSOptedVoiEvent } from "utilities/full-story";
import { Spinner } from "components/v2/spinner/spinner";
import useDesktopChecker from "hooks/useDesktopChecker";

export const TOSDrawer = ({
  verificationType,
  showVerificationDrawer,
  setShowVerificationDrawer,
  forDashboard = true,
  handleSuccessfullVerification,
}: {
  verificationType: VerificationType;
  showVerificationDrawer: boolean;
  setShowVerificationDrawer: (show: boolean) => void;
  forDashboard?: boolean;
  handleSuccessfullVerification: () => void;
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [error, setError] = useState(false);
  const isDesktop = useDesktopChecker();

  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const userRole = useSelector(getUserRole);

  const isPrimary = (): boolean => {
    const userRoleNormalized = (userRole || "").toLowerCase();
    const isSpouse = userRoleNormalized === "spousalcoborrower" || userRoleNormalized === "spouse";
    return !isSpouse;
  };

  const userApplicationData: CreateVerificationOrder = {
    email: "testNAFUser@example.com",
    consentTS: new Date().toISOString(),
    nhDealapplicationId: nhDealApplicationId,
    isPrimary: isPrimary(),
    verificationType: verificationType,
  };
  const checkError = () => error && !isError;

  const handleError = (isError: boolean) => {
    if (checkError()) {
      setError(false);
    } else if (!error && isError) {
      setError(true);
    }
  };
  const [CreateVerificationOrder, { isLoading, isSuccess, isError, data }] = useCreateVerificationOrderMutation();
  const [syncVerificationData, { isLoading: isSynced }] = useSyncVerificationDataMutation();
  let orderId = "";
  const onCreateOrder = async () => {
    await CreateVerificationOrder(userApplicationData);
    toggleModal();
  };

  const toggleModal = () => {
    setShowIframe(!showIframe);
  };

  const handleVerificationSuccess = async() => {
    setShowIframe(false);
    if (orderId) {
      await syncVerificationData(orderId);
    }
    handleSuccessfullVerification();
  };

  const closeDrawer = () => {
    setIsChecked(false);
    setError(false);
    setShowIframe(false);
    setShowVerificationDrawer(false);
  };

  useEffect(() => {
    if (isSuccess && data) {
      if (verificationType === VerificationType.VOA) {
        trackFSOptedVoaEvent(data.created);
      } else {
        trackFSOptedVoiEvent(data.created);
      }
    }
  }, [isSuccess, data, verificationType]);

  if (isSuccess && data) {
    orderId = data.id;
  }

  return (
    <Drawer
      isOpen={showVerificationDrawer}
      onClose={closeDrawer}
      title={isDesktop ? "Verification of Assets" : ""}
      type={DrawerType.Voa}
      customCss="tos-drawer"
      centerContent
    >
      {(isLoading || isSynced) && <Spinner isApi />}

      {!error && !isLoading && !showIframe && !isSynced && (
        <div className="tosdrawer-container">
          <div className="tosdrawer-container__body">
            <div className="tosdrawer-container__body--checkbox">
              <Checkbox onChange={(checked: boolean) => setIsChecked(checked)} checkboxState={isChecked} />
              <span className="tosdrawer-container__body--checkbox__text">Check here to agree to terms below.</span>
            </div>
            <span className="tosdrawer-container__body--text1">
              I agree to the{" "}
              <a href={VOA_TOS_LINK} target="_blank" rel="noreferrer">
                Terms of Service
              </a>{" "}
              and request that AccountChek® act as an intermediary on my behalf to furnish information to prospective creditor in order to further my
              application.
            </span>
          </div>
          <div className="tosdrawer-container__button">
            <Button label="Continue" variant="primary" onClick={() => onCreateOrder()} disabled={!isChecked} />
            <Button label="Cancel" variant="outline" onClick={closeDrawer} />
          </div>
        </div>
      )}

      {isSuccess && orderId && showIframe && (
        <SsoIframe
          orderId={orderId}
          showModal={showIframe}
          toggleModal={toggleModal}
          handleError={handleError}
          onClose={handleVerificationSuccess}
          forDashboard={forDashboard}
        />
      )}

      {error && <div className="toc-error">AccountChek is unavailable at this time. Please try again later.</div>}
    </Drawer>
  );
};
